.question {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-3);
  padding: var(--tuna-spacing-4);
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.title {
  font-size: var(--tuna-font-size-3);
  margin: 0;
}

.scoreChip {
  padding: var(--tuna-spacing-1) var(--tuna-spacing-2);
  font-size: var(--tuna-font-size-0);
  background: var(--tuna-color-surface);
  border: 1px solid var(--tuna-color-border);
  border-radius: var(--tuna-radius-1);
}

.prompt {
  margin: 0;
  font-size: var(--tuna-font-size-1);
  color: var(--tuna-color-text-subtle);
}

.chordLine {
  display: flex;
  align-items: center;
  gap: var(--tuna-spacing-2);
}

.chordName {
  font-size: var(--tuna-font-size-3);
  font-weight: 700;
}

.keyContext {
  font-size: var(--tuna-font-size-1);
  color: var(--tuna-color-text-subtle);
}

.hearItButton {
  margin-left: auto;
}

.cardGrid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: var(--tuna-spacing-2);
}

@media (max-width: 640px) {
  .cardGrid {
    grid-template-columns: 1fr;
  }
}
